import React from 'react'
import { ModalProvider } from 'react-aria'
import ToastProvider from './Toast/ToastProvider'

type AppProviderProps = {
  children: React.ReactNode
}

export function AppProvider(props: AppProviderProps) {
  return (
    <ModalProvider>
      <ToastProvider>{props.children}</ToastProvider>
    </ModalProvider>
  )
}
